import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M5.25 6.91A.75.75 0 016 6.16h12a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M11.333 4.75c-.69 0-1.25.56-1.25 1.25v.91h-1.5V6a2.75 2.75 0 012.75-2.75h1.334A2.75 2.75 0 0115.417 6v.91h-1.5V6c0-.69-.56-1.25-1.25-1.25h-1.334zM6 6.91L8 20h8l2-13.09H6zm6.5 3.636a.5.5 0 10-1 0v5.818a.5.5 0 101 0v-5.819zm-3.224-.5a.476.476 0 01.55.423l.666 5.818a.525.525 0 01-.435.576.477.477 0 01-.549-.423l-.667-5.818a.525.525 0 01.435-.575zm5.883.576a.525.525 0 00-.435-.575.476.476 0 00-.55.422l-.666 5.818a.525.525 0 00.435.576.476.476 0 00.549-.423l.666-5.818z",
      "clip-rule": "evenodd"
    })
  ]))
}